import { Link, useLocation } from "react-router-dom";
import { useTheme } from "@/context/ThemeContext";

const PAGE_TITLES: Record<string, string> = {
  "/rule-settings": "规则设置",
  "/fortune-analysis": "运势分析",
  "/profile": "个人中心",
  "/member_benefits": "会员权益",
  "/vip": "会员中心",
  "/liuyao-report": "六爻报告",
};

export default function ComingSoon() {
  const location = useLocation();
  const { effectiveTheme } = useTheme();
  const isLight = effectiveTheme === "light";
  const title = PAGE_TITLES[location.pathname] || "功能";

  return (
    <div
      className={`min-h-screen flex items-center justify-center px-5 ${
        isLight ? "bg-[#f5f5f7]" : "bg-cosmic-950"
      }`}
    >
      <div
        className="w-full max-w-md rounded-2xl border p-8 text-center"
        style={{
          background: "var(--bg-card)",
          borderColor: "var(--border-color)",
          color: "var(--text-primary)",
        }}
      >
        <div
          className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl"
          style={{ background: "var(--bg-track)", color: "var(--accent-primary)" }}
        >
          <i className="ri-time-line text-2xl" />
        </div>
        <h1 className="text-2xl font-bold mb-2">{title}</h1>
        <p className="text-base leading-relaxed mb-6" style={{ color: "var(--text-secondary)" }}>
          当前功能正在整理中，敬请期待。
        </p>
        <Link
          to="/experience"
          className="inline-flex h-11 items-center justify-center rounded-full px-6 text-sm font-semibold transition-opacity hover:opacity-90"
          style={{ background: "var(--accent-primary)", color: "#fff" }}
        >
          返回测算页
        </Link>
      </div>
    </div>
  );
}
